import React, { useEffect, useState, useRef } from "react";
import BackBtn from "../../common/backBTN";

function BiundEwallet() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [existingContracts, setExistingContracts] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const debounceRef = useRef(null);

  // Fetch existing e-wallet/phone contracts for current user
  useEffect(() => {
    const fetchOther = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setExistingContracts(data.data || []);
        }
      } catch (err) {
        console.error('Failed to load existing numbers:', err);
      }
    };
    fetchOther();
  }, []);

  const normalize = (v) => (v || "").replace(/\D/g, "");

  const checkExistsLocal = (value) => {
    const target = normalize(value);
    if (!target) return false;
    return existingContracts.some((c) => normalize(c.contract_value) === target);
  };

  const tryExistsEndpoint = async (url, token) => {
    try {
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
        },
      });
      if (!res.ok) return null;
      const data = await res.json();
      if (typeof data?.exists === 'boolean') return data.exists;
      if (typeof data?.data?.exists === 'boolean') return data.data.exists;
      if (typeof data?.success !== 'undefined' && typeof data?.exists === 'boolean') return data.exists;
      return null;
    } catch (_) {
      return null;
    }
  };

  const validateNumber = async (value) => {
    setIsChecking(true);
    let exists = false;

    const token = localStorage.getItem('token');
    const digits = normalize(value);
    if (digits && token) {
      const base = process.env.REACT_APP_API_URL;
      // Try a few likely global-check endpoints; stop on first conclusive answer
      const candidates = [
        `${base}/api/number/exists?phone=${encodeURIComponent(digits)}`,
        `${base}/api/check/number?phone=${encodeURIComponent(digits)}`,
        `${base}/api/phone/exists?phone=${encodeURIComponent(digits)}`,
        `${base}/api/check/phone?phone=${encodeURIComponent(digits)}`,
        // Alternate param name
        `${base}/api/number/exists?number=${encodeURIComponent(digits)}`,
        `${base}/api/check/number?number=${encodeURIComponent(digits)}`,
      ];
      for (const url of candidates) {
        const res = await tryExistsEndpoint(url, token);
        if (res === true) { exists = true; break; }
        if (res === false) { exists = false; break; }
      }
    }

    // Fallback to local list if global not available
    if (!exists) {
      exists = checkExistsLocal(value);
    }

    if (exists) {
      setErrorMsg("This number exists in our records. Try a different number.");
    } else {
      setErrorMsg("");
    }
    setIsChecking(false);
    return !exists;
  };

    const addPhoneNumber = async () => {
        if (isButtonDisabled) return;
        
      // Basic client-side format check (11 digits typical), adjust if needed
      const digits = normalize(phoneNumber);
      if (!digits || digits.length < 6) {
        setErrorMsg("Please enter a valid account number.");
        return;
      }

      // Prevent submit if number already exists locally
      const ok = await validateNumber(phoneNumber);
      if (!ok) return;

        setIsButtonDisabled(true);
    
        const token = localStorage.getItem('token');
        if (!token) {
            console.error('User token not found.');
            setIsButtonDisabled(false);
            return;
        }
    
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/add/number`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: phoneNumber, isverify: 1 }),
            });
    
            if (!response.ok) {
          let errorData = {};
          try { errorData = await response.json(); } catch (_) {}
          const msg = (errorData && (errorData.message || errorData.error)) || 'Unknown error';
          // If backend signals duplication, show user-friendly message
          if ((msg + '').toLowerCase().includes('exist')) {
            setErrorMsg("This number exists in our records. Try a different number.");
          } else {
            setErrorMsg(msg);
          }
                setIsButtonDisabled(false);
                return;
            }
            if (response.ok) {
                alert('E-wallet bound successfully!');
                window.location.href = '/ewalletList';
            }
    
            
    
            
    
        } catch (error) {
            console.error('Error sending code:', error);
            setIsButtonDisabled(false);
        }
    };

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="EN addBank_root">
        <div className="mc-header-wrap">
          <div id="mc-header" className="mc-navbar-blue mc-addBankCardPix mc-default-header am-navbar am-navbar-light">
            <BackBtn/>
            <div className="am-navbar-title">Bind E-wallet</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        <div className="flex-container account-form bank-card-container">
          <div className="ewallet-group-wrapper"></div>

          <div className="type-group-area">
            <div className="error" />
            <div className="account-form-group">
              <div className="mc-account-list">
                <svg className="am-icon am-icon-mcBankCard_b967cbbc am-icon-md txt-svg">
                  <use xlinkHref="#mcBankCard_b967cbbc" />
                </svg>
                <div className="input-group">
                  <input
                    className="input-base bankCardInput"
                    placeholder="Please fill in account number"
                    name="bankCard"
                    value={phoneNumber}
                    onChange={(e) => {
                      const v = e.target.value;
                      setPhoneNumber(v);
                      if (debounceRef.current) clearTimeout(debounceRef.current);
                      debounceRef.current = setTimeout(() => {
                        validateNumber(v);
                      }, 300);
                    }}
                    onBlur={() => validateNumber(phoneNumber)}
                    style={{ transition: "0.15s linear" }}
                  />
                </div>
                <div className="error" style={{ color: '#d9534f', minHeight: 18 }}>
                  {isChecking ? 'Checking...' : errorMsg}
                </div>
              </div>
            </div>
          </div>

          <span
            className={`am-button btn-gray`}
            onClick={!isButtonDisabled && !errorMsg ? addPhoneNumber : undefined}
            aria-disabled={isButtonDisabled || !!errorMsg}
          >
            Submit
          </span>
        </div>
      </div>
    </div>
  );
}

export default BiundEwallet;
